export default __webpack_public_path__ + "static/media/005-arrow-down-direct.b9fac8a4.svg";